import * as React from "react";
import type { SVGProps } from "react";
const SvgIconRoomCount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M443.5 68.5v375H182.64v-10.92h29.05v-95.99h41.88v10.92h-30.96v85.07h209.97v-85.07H319.81v-10.92h112.77v-85.04H211.69v-52.62h10.92v41.7h209.97V79.42H222.61v56.31h-10.92V79.42H79.42v161.21h52.93v-41.7h10.92v93.11h-10.92v-40.49H79.42v181.03h27.7v10.92H68.5v-375z"
    />
  </svg>
);
export default SvgIconRoomCount;
